import { render, staticRenderFns } from "./BPInstance.vue?vue&type=template&id=aff38ffc&"
import script from "./BPInstance.vue?vue&type=script&lang=js&"
export * from "./BPInstance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports